import {ErrorType} from "./error-type";
import FieldProto from "../../fields3/proto/field-proto";
import ErrorProto from "./error";

export default class ErrorFieldRequired extends ErrorProto {

    public field  : FieldProto

    constructor(field:FieldProto) {
        super()

        this.type       = ErrorType.FieldRequired
        this.field      = field
    }

    get message() {
        return "Field "+this.field.label+" is required"
    }


}